// extracted by mini-css-extract-plugin
export default {"header":"mN","container":"nN","accordeonitem":"oN","itemsticky":"pN","itemopen":"qN","open":"rN","productname":"sN","productinfo":"tN","flavorstext":"uN","invalidlimit":"vN","limit":"wN","scrollUpAccordion":"xN","wrapper":"yN"};
    if(module.hot) {
      // 1713361652316
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  